/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function ChainsRouter($stateProvider) {
  'ngInject';

  $stateProvider
    .state('app.chains', {
      url: '/chains/',
      template: '<app-chains></app-chains>',
      data: {
        authorizedPermissions: ['MERCHANT_READ'],
      },
    })
    .state('app.chains-edit', {
      url: '/chains/edit/:chainId',
      template: '<app-chains-edit></app-chains-edit>',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
    })
    .state('app.chains-create', {
      url: '/chains/create/:merchantId',
      template: '<app-chains-create></app-chains-create>',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/chains/chains.router.js